import styled from 'styled-components';

import Button from '../Button/Button';
import { ButtonStyled } from '../Button/Button.styled';

type LinkPropsT = {
  isActive: boolean;
};

export const BreadcrumbsWrapperStyled = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 40px;
`;

export const LinkStyled = styled(Button)<LinkPropsT>`
  display: flex;
  align-items: center;
  gap: 10px;
  text-transform: capitalize;

  ${({ theme, isActive }) => `
    color: ${isActive ? theme.primaryColour : theme.textColour};  
    font-weight: ${theme.fontWeights.medium};

    ${NumberStyled} {
      background:${isActive ? theme.primaryColour : theme.textColour}; 
    }
  `}
`;

export const NumberStyled = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 30px;
  height: 30px;
  border-radius: 50%;

  ${({ theme }) => `
    color: ${theme.whiteColour};
  `}
`;

export const MobileCrumbStyled = styled.li`
  display: flex;
  justify-content: space-between;
  width: 100%;

  ${ButtonStyled} {
    &:last-of-type {
      transform: rotate(180deg);
    }
  }
`;
